import styled from 'styled-components';

import { colors } from 'theme/theme';

export const CurrencyInputContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  align-items: center;
`;

export const CurrencyInputSign = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  top: 12px;
  left: 18px;
  font-size: 18px;
  letter-spacing: 0;
  padding: 0 0 0 12px;
  color: ${colors.lightContentGrey};
  width: 24px;
  height: 100%;
`;
